import React, { Component } from 'react'

import { Modal, Button, ControlLabel, ToggleButton } from 'react-bootstrap';

import { connect } from 'react-redux';

import { saveCustomerPerson } from "reducers/customer/customerActions";
import { showWarningMessage } from 'reducers/application/applicationActions';
import CIExpSelect from "components/CIExpSelect/CIExpSelect";
import DptSelect from "components/CIExpSelect/DptSelect";
import GenderSelect from "components/GenderSelect/GenderSelect";

import { SCREEN_THRESHOLD } from "../../global/constants";

import Loader from "components/elements/loader/Loader";

import PersonTypeahead from "components/PersonTypeahead/PersonTypeahead";

import classNames from 'classnames';
import MaterialIcon from 'material-icons-react';
import NationalityTypeahead from "components/Typeaheads/NationalityTypeahead";
import Datetime from "react-datetime";

class CustomerModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            middleName: "",
            lastName: "",
            nationality: "",
            birthDate: null,
            ci: "",
            documentIssuedPlace: null,
            dpt: null,
            gender: null,
            auxMobilePhone: "",
            auxPhone: "",
            auxAddress: "",
            auxEmail: "",
            id: 0,
            nameError: null,
            middleNameError: null,
            lastNameError: null,
            nationalityError: null,
            ciError: null,
            documentIssuedPlaceError: null,
            dptError: null,
            auxMobilePhoneError: null,
            auxPhoneError: null,
            auxAddressError: null,
            auxEmailError: null,
            loading: false,
            selectedPerson: null,
            showSearchPerson: false
        }
        this.isDesktop = window.innerWidth > SCREEN_THRESHOLD
    }

    cleanFields() {
        this.setState({
            id: 0,
            name: "",
            middleName: "",
            lastName: "",
            nationality: "",
            ci: "",
            documentIssuedPlace: null,
            dpt: null,
            auxMobilePhone: "",
            auxPhone: "",
            auxAddress: "",
            auxEmail: "",
            gender: null,
            birthDate: null
        });
    }

    save() { 
        if (this.validate()) {
            this.setState({ loading: true });
            let promise = new Promise((resolve, reject) => {
                let dto = {
                    id: this.state.id,
                    name: this.state.name,
                    middleName: this.state.middleName,
                    lastName: this.state.lastName,
                    nationality: this.state.nationality,
                    ci: this.state.ci,
                    auxMobilePhone: this.state.auxMobilePhone,
                    auxPhone: this.state.auxPhone,
                    auxAddress: this.state.auxAddress,
                    auxEmail: this.state.auxEmail,
                    gender: this.state.gender.value,
                    birthDate: this.state.birthDate
                };
                this.props.saveCustomerPerson(dto, this.state.documentIssuedPlace.value, this.state.dpt.value, resolve, reject, );
            });
            promise.then(() => {
                this.props.updateCustomer(this.props.customer);
                this.cleanFields();
                this.setState({ loading: false, selectedPerson: null });
                this.props.onHide();
            }, () => {
                this.setState({ loading: false });
            });
        }
    }

    onInputChange(evt, clean) {
        this.setState({ [evt.target.name]: evt.target.value });
        clean();
    }

    onSearchToogleChange(evt) {
        this.setState({ showSearchPerson: !this.state.showSearchPerson });
        console.log(!this.state.showSearchPerson);
    }

    onChangeMobilePhone(evt) {
        const value = evt.target.value;
        if (value === '' || value.length <= 20) {
            this.cleanAuxMobilePhoneError();
            this.setState({ auxMobilePhone: evt.target.value });
        }
    }

    onChangePhone(evt) {
        const value = evt.target.value;
        if (value === '' || value.length <= 20) {
            this.cleanAuxPhoneError();
            this.setState({ auxPhone: evt.target.value });
        }
    }

    isNormalInteger(str) {
        return /^\+?(0|[1-9]\d*)$/.test(str);
    }

    handleDocIssuedPlaceChange(exp) {
        if (exp != null) {
            this.cleanDocumentIssuedPlaceError();
            this.setState({ documentIssuedPlace: exp })
        } else {
            this.setState({ documentIssuedPlace: null })
        }
    }

    handleDptChange(exp) {
        if (exp != null) {
            this.cleanDptError();
            this.setState({ dpt: exp })
        } else {
            this.setState({ dpt: null })
        }
    }

    handleGenderChange(gender) {
        if (gender != null) {
            this.cleanGenderError();
            this.setState({ gender: gender })
        } else {
            this.setState({ gender: null })
        }
    }

    handleNationalityChange(nationality) {
        if (nationality != null) {
            this.cleanNationalityError();
            this.setState({ nationality: nationality })
        } else {
            this.setState({ nationality: null })
        }
    }

    handleBirthDateChange(birthDate) {
        if (birthDate != null) {
            this.cleanBirthDateError();
            this.setState({ birthDate: birthDate })
        } else {
            this.setState({ birthDate: null })
        }
    }

    validate() {
        this.cleanErrors();
        if (this.state.name === "") {
            this.props.showWarningMessage("Por favor ingrese Nombre");
            this.setState({ nameError: "Por favor ingrese Nombre" });
            return false;
        }

        if (this.state.lastName === "") {
            this.props.showWarningMessage("Por favor ingrese Apellidos");
            this.setState({ lastNameError: "Por favor ingrese Apellidos" });
            return false;
        }

        if (this.state.gender === null || this.state.gender === "") {
            this.props.showWarningMessage("Por favor ingrese Género");
            this.setState({ genderError: "Por favor ingrese Género" });
            return false;
        }

        if (this.state.birthDate === null || this.state.birthDate === "") {
            this.props.showWarningMessage("Por favor ingrese Fecha de nacimiento");
            this.setState({ birthDateError: "Por favor ingrese Fecha de nacimiento" });
            return false;
        }

        if (this.state.nationality === "") {
            this.props.showWarningMessage("Por favor ingrese Nacionalidad");
            this.setState({ nationalityError: "Por favor ingrese Nacionalidad válida" });
            return false;
        }

        if (this.state.ci === "") {
            this.props.showWarningMessage("Por favor ingrese CI");
            this.setState({ ciError: "Por favor ingrese CI" });
            return false;
        }

        if (this.state.documentIssuedPlace === null || this.state.documentIssuedPlace === "") {
            this.props.showWarningMessage("Por favor ingrese Lugar de Expedición");
            this.setState({ documentIssuedPlaceError: "Por favor ingrese Lugar de Expedición" });
            return false;
        }

        if (this.state.dpt === null || this.state.dpt === "") {
            this.props.showWarningMessage("Por favor ingrese un departamento");
            this.setState({ dptError: "Por favor ingrese un Departamento" });
            return false;
        }

        if (this.state.auxMobilePhone === "") {
            this.props.showWarningMessage("Por favor ingrese un número de teléfono");
            this.setState({ auxMobilePhoneError: "Por favor ingrese un número de teléfono" });
            return false;
        }

        if (this.state.auxAddress === "") {
            this.props.showWarningMessage("Por favor ingrese Dirección");
            this.setState({ auxAddressError: "Por favor ingrese Dirección" });
            return false;
        }

        if (this.state.auxEmail === "") {
            this.props.showWarningMessage("Por favor ingrese correo electrónico");
            this.setState({ auxEmailError: "Por favor ingrese correo electrónico" });
            return false;
        }

        if (!this.validEmail(this.state.auxEmail)) {
            this.props.showWarningMessage("Por favor ingrese un correo electrónico válido Ej: test@gmail.com");
            this.setState({ auxEmailError: "Por favor ingrese un correo electrónico válido Ej: test@gmail.com" });
            return false;
        }

        return true;
    }

    cleanNameError = () => {
        this.setState({ nameError: null });
    }

    cleanMiddleNameError = () => {
        this.setState({ middleNameError: null });
    }

    cleanLastNameError = () => {
        this.setState({ lastNameError: null });
    }

    cleanNationalityError = () => {
        this.setState({ nationalityError: null });
    }

    cleanBirthDateError = () => {
        this.setState({ birthDateError: null });
    }

    cleanCiError = () => {
        this.setState({ ciError: null });
    }

    cleanDocumentIssuedPlaceError = () => {
        this.setState({ documentIssuedPlaceError: null });
    }

    cleanDptError = () => {
        this.setState({ dptError: null });
    }

    cleanGenderError = () => {
        this.setState({ genderError: null });
    }

    cleanAuxMobilePhoneError = () => {
        this.setState({ auxMobilePhoneError: null });
    }

    cleanAuxPhoneError = () => {
        this.setState({ auxPhoneError: null });
    }

    cleanAuxAddressError = () => {
        this.setState({ auxAddressError: null });
    }

    cleanAuxEmailError = () => {
        this.setState({ auxEmailError: null });
    }

    cleanErrors = () => {
        this.cleanNameError();
        this.cleanMiddleNameError();
        this.cleanLastNameError();
        this.cleanNationalityError();
        this.cleanCiError();
        this.cleanDocumentIssuedPlaceError();
        this.cleanDptError();
        this.cleanAuxMobilePhoneError();
        this.cleanAuxPhoneError();
        this.cleanAuxAddressError();
        this.cleanAuxEmailError();
    }

    validEmail(value) {
        let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return filter.test(value);
    }

    handlePersonSelectionChange(person) {
        console.log("handlePersonSelectionChange", person);
        if (person == null) {
            this.cleanFields();
        } else {
            this.setState({
                id: person.id,
                name: person.name,
                middleName: person.middleName,
                lastName: person.lastName,
                nationality: person.nationality == null ? "" : person.nationality,
                ci: person.ci == null || person.ci == 0 ? "" : person.ci,
                documentIssuedPlace: person.documentIssuedPlace == null ? "" : { value: person.documentIssuedPlace, label: '' }
            });
        }
    }

    render() {
        let modalSize = !this.isDesktop ? 'sm' : 'md';

        const { nameError,
            lastNameError,
            nationalityError,
            ciError,
            documentIssuedPlaceError,
            dptError,
            auxAddressError,
            auxEmailError,
            auxMobilePhoneError,
            genderError,
            birthDateError } = this.state;
        const nameClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': nameError != null }
        );
        const lastNameClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': lastNameError != null }
        );
        const nationalityClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': nationalityError != null }
        );
        const ciClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': ciError != null }
        );
        const documentIssuedPlaceClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': documentIssuedPlaceError != null }
        );
        const dptClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': dptError != null }
        );
        const auxAddressClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': auxAddressError != null }
        );
        const auxEmailClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': auxEmailError != null }
        );
        const auxMobilePhoneClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': auxMobilePhoneError != null }
        );
        const genderClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': genderError != null }
        );
        const birthDateClass = classNames('form-group customer-modal__form-group col-sm-12 col-md-6',
            { 'has-error': birthDateError != null }
        );

        return (
            <Modal
                {...this.props}
                animation={false}
                bsSize={modalSize}
                aria-labelledby="contained-modal-title-sm"
                backdrop={"static"} >
                <Modal.Header>
                    <Modal.Title>Nuevo Afiliado</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="form">


                        <div className="row customer-modal__row">
                            <div className="form-group customer-modal__form-group col-sm-12 col-md-12">
                                <div className="float-right">
                                    <ToggleButton id="searchPerson" className="btn-primary btn btn-default "
                                        title="Buscar personas existentes"
                                        style={
                                            { lineHeight: "0px", margin: "0px" }
                                        }
                                        type="checkbox"
                                        onChange={(evt) => this.onSearchToogleChange(evt)}
                                        value={this.state.showSearchPerson} >
                                        <MaterialIcon size="25px" color="white" icon="search" />
                                    </ToggleButton>
                                </div>
                            </div>
                        </div>


                        {this.state.showSearchPerson && <div className="row customer-modal__row">
                            <div className="form-group customer-modal__form-group col-sm-12 col-md-12">
                                <ControlLabel><b>Busca una persona:</b></ControlLabel>
                                <PersonTypeahead
                                    onRef={ref => (this.personTypeahead = ref)}
                                    selection={this.state.selectedPerson}
                                    handleChange={(person) => this.handlePersonSelectionChange(person)} />
                            </div>
                        </div>
                        }

                        <div className="row customer-modal__row">
                            <div className={nameClass}>
                                <ControlLabel><b>Nombre:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="text" className="form-control"
                                        onChange={(evt) => this.onInputChange(evt, this.cleanNameError)}
                                        name="name"
                                        value={this.state.name}
                                        placeholder="Nombre" />
                                </div>
                                <span className="help-block">{nameError}</span>
                            </div>
                            <div className="form-group customer-modal__form-group col-sm-12 col-md-6">
                                <ControlLabel><b>Segundo Nombre:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="text" className="form-control"
                                        onChange={(evt) => this.onInputChange(evt, () => { })}
                                        name="middleName"
                                        value={this.state.middleName}
                                        placeholder="Segundo Nombre" />
                                </div>
                            </div>
                        </div>
                        <div className="row customer-modal__row">
                            <div className={lastNameClass}>
                                <ControlLabel><b>Apellidos:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="text" className="form-control"
                                        onChange={(evt) => this.onInputChange(evt, this.cleanLastNameError)}
                                        name="lastName"
                                        value={this.state.lastName}
                                        placeholder="Apellidos" />
                                </div>
                                <span className="help-block">{lastNameError}</span>
                            </div>

                            <div className={genderClass}>
                                <ControlLabel><b>Género:</b></ControlLabel>
                                <div className="input-group">
                                    <GenderSelect
                                        className="width-100"
                                        selection={this.state.gender}
                                        value={this.state.gender}
                                        handleChange={(gender) => this.handleGenderChange(gender)} />
                                </div>
                                <span className="help-block">{genderError}</span>
                            </div>
                        </div>

                        <div className="row customer-modal__row">
                            <div className={birthDateClass}>
                                <ControlLabel><b>Fecha de nacimiento:</b></ControlLabel>
                                <div className="input-group">
                                    <Datetime className="flex-grow right-4"
                                        onChange={(evt) => this.handleBirthDateChange(evt)}
                                        timeFormat={false}
                                        value={this.state.birthDate}
                                        inputProps={{ placeholder: "Fecha de Nacimiento", readOnly: true }} />
                                </div>
                                <span className="help-block">{birthDateError}</span>
                            </div>

                            <div className={nationalityClass}>
                                <ControlLabel><b>Nacionalidad:</b></ControlLabel>
                                <div className="input-group">
                                    <NationalityTypeahead
                                        handleChange={(evt) => this.handleNationalityChange(evt)}
                                        value={this.state.nationality} />
                                </div>
                                <span className="help-block">{nationalityError}</span>
                            </div>

                        </div>

                        <div className="row customer-modal__row">
                            <div className={ciClass}>
                                <ControlLabel><b>CI:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="text" className="form-control"
                                        onChange={(evt) => this.onInputChange(evt, this.cleanCiError)}
                                        maxlength="10"
                                        name="ci"
                                        value={this.state.ci}
                                        placeholder="CI" />
                                </div>
                                <span className="help-block">{ciError}</span>
                            </div>
                            <div className={documentIssuedPlaceClass}>
                                <ControlLabel><b>Lugar de expedición(CI):</b></ControlLabel>
                                <div className="input-group">
                                    <CIExpSelect
                                        selection={this.state.documentIssuedPlace}
                                        value={this.state.documentIssuedPlace}
                                        handleChange={(exp) => this.handleDocIssuedPlaceChange(exp)} />
                                </div>
                                <span className="help-block">{documentIssuedPlaceError}</span>
                            </div>
                        </div>

                        <div className="row customer-modal__row">
                            <div className={dptClass}>
                                <ControlLabel><b>Departamento:</b></ControlLabel>
                                <div className="input-group">
                                    <DptSelect
                                        selection={this.state.dpt}
                                        value={this.state.dpt}
                                        handleChange={(exp) => this.handleDptChange(exp)}/>
                                </div>
                                <span className="help-block">{dptError}</span>
                            </div>
                            <div className={auxMobilePhoneClass}>
                                <ControlLabel><b>Celular:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="text" className="form-control"
                                           value={this.state.auxMobilePhone}
                                           onChange={(evt) => this.onChangeMobilePhone(evt)}
                                           name="auxMobilePhone"
                                           placeholder="Celular" />
                                </div>
                                <span className="help-block">{auxMobilePhoneError}</span>
                            </div>

                        </div>


                        <div className="row customer-modal__row">
                            <div className={auxAddressClass}>
                                <ControlLabel><b>Dirección:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="text" className="form-control"
                                        onChange={(evt) => this.onInputChange(evt, this.cleanAuxAddressError)}
                                        name="auxAddress"
                                        placeholder="Dirección" />
                                </div>
                                <span className="help-block">{auxAddressError}</span>
                            </div>
                            <div className={auxEmailClass}>
                                <ControlLabel><b>Correo electrónico:</b></ControlLabel>
                                <div className="input-group">
                                    <input type="email" className="form-control"
                                        onChange={(evt) => this.onInputChange(evt, this.cleanAuxEmailError)}
                                        name="auxEmail"
                                        placeholder="Email" />
                                </div>
                                <span className="help-block">{auxEmailError}</span>
                            </div>
                        </div>
                    </form>
                </Modal.Body>

                {!this.state.loading ?
                    <Modal.Footer>
                        <Button onClick={this.props.onHide} >Cerrar</Button>
                        <Button onClick={() => this.save()} bsStyle="primary">Guardar</Button>

                    </Modal.Footer> :
                    <Modal.Footer>
                        <div className="w-100">
                            <Loader classes="password-modal__spinner" show={true} />
                        </div>
                    </Modal.Footer>
                }

            </Modal>
        )
    }
}
const mapStateToProps = state => ({
    customer: state.customer.item
});
export default connect(
    mapStateToProps,
    { saveCustomerPerson, showWarningMessage }
)(CustomerModal);



// WEBPACK FOOTER //
// ./src/components/CustomerModal/CustomerModal.jsx